/// <amd-module name="Build/Run/Components/BaseStatus" />
import * as React from "react";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";


export interface IBaseStatusProps extends IBaseStatusOptions {
    text: string | null;
    extendedText?: string | null;
    item?: React.ReactNode;
    warningStatus?: boolean,
    iconName: string;
    rejectedChecks?: boolean;
}

export interface IBaseStatusOptions {
    onClick?: (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void;
    href?: string;
    onData?: (hasData: boolean) => void;
}

export function BaseStatus(props: IBaseStatusProps) {
    props.onData && props.onData(!!props.text);
    if (!props.text) {
        return null;
    }

    return <FPSLink className="body-m font-size" subtle={true} onClick={props.onClick} href={props.href} removeUnderline={true}>
        <span className="flex-row">
            <span className="flex-column"> {!props.warningStatus && <Icon iconName={props.iconName} className="base-status-icon-margin"/>}</span>
            <span className={css("flex-column", (props.warningStatus || props.rejectedChecks) && "rejected-check-base-status")}>
                <span>{props.text}</span>
                <span>{props.extendedText}</span>
            </span>
            {!!props.item && props.item}
        </span>
    </FPSLink>;
}